<template>
  <div class="inline_spinner">
    <div class="gfx">
      <div class="tick"
           v-for="i in ticks" :key="i"
           :style="styleTick(i)"></div>
    </div>
    <div class="label" v-if="label">{{ label }}</div>
  </div>
</template>

<script>

export default {
    name  : "InlineSpinner",
    props : {
        ticks : {
            type    : Number,
            default : 5
        },
        label : {
            type    : String,
            default : ""
        }
    },
    methods : {
        styleTick : function(i) {
            return {
                animationDelay : `${- Math.round(500 * i / this.ticks)}ms`
            };
        }
    }
};

</script>

<style scoped>

.inline_spinner {
    display:inline-flex;
    padding:10px;
    align-items:center;
}

.inline_spinner .label:not(:empty) {
    padding-left:15px;
    font-weight:200;
}

.inline_spinner .tick {
    display:inline-block;
    position:relative;
    width:6px;
    height:30px;
    margin:0px 5px;
    background-image:-webkit-linear-gradient(to bottom, var(--main-orange), var(--dark-orange));
    background-image:-moz-linear-gradient(to bottom, var(--main-orange), var(--dark-orange));
    background-image:-ms-linear-gradient(to bottom, var(--main-orange), var(--dark-orange));
    background-image:linear-gradient(to bottom, var(--main-orange), var(--dark-orange));
    animation-name:ch-sway;
    animation-timing-function:ease-in-out;
    animation-iteration-count:infinite;
    animation-duration:500ms;
    animation-direction:alternate;
}

.inline_spinner .tick:before {
    content:"";
    position:absolute;
    top:2px;
    left:2px;
    width:calc(100% - 4px);
    height:calc(100% - 4px);
    background-color:var(--core-white);
}

@keyframes ch-sway {
    0% { transform:translateX(-20px) }
    100% { transform:translateX(20px) }
}

</style>
